import type { SVGProps } from 'react';

const SvgMapMarker = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20" {...props}>
    <path
      fill={props.color}
      d="M7 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5M7 0C3.13 0 0 3.13 0 7c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7"
    />
  </svg>
);

export default SvgMapMarker;
